import React from "react";
import "./toolbar.css";
import { MdDashboard } from "react-icons/md";
import { MdNotifications } from "react-icons/md";
import { MdAssignment } from "react-icons/md";
import { BsFillPeopleFill } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { FaPeopleCarry } from "react-icons/fa";
import { MdDynamicFeed } from "react-icons/md";
import { BiLogOut } from "react-icons/bi";
import { IoStorefrontOutline } from "react-icons/io5";
import { MdCategory } from "react-icons/md";
import { MdLocalOffer } from "react-icons/md";
import { MdViewCarousel } from "react-icons/md";
import { MdShowChart } from "react-icons/md";
import { MdHistory } from "react-icons/md";
import { MdSettings } from "react-icons/md";
import { BsChevronLeft } from "react-icons/bs";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { path: "/admin/dashboard", icon: MdDashboard, label: "Dashboard" },
  { path: "/admin/orders", icon: MdAssignment, label: "Orders" },
  { path: "/admin/customers", icon: BsFillPeopleFill, label: "Customers" },
  { path: "/admin/staff", icon: FaPeopleCarry, label: "Staff" },
  { path: "/admin/products", icon: IoStorefrontOutline, label: "Products" },
  { path: "/admin/categories", icon: MdCategory, label: "Categories" },
  { path: "/admin/coupons", icon: MdLocalOffer, label: "Coupons" },
  { path: "/admin/banners", icon: MdViewCarousel, label: "Banners" },
  { path: "/admin/sales", icon: MdShowChart, label: "Sales" },
  { path: "/admin/feedbacks", icon: MdDynamicFeed, label: "Reviews" },
  { path: "/admin/question", icon: MdNotifications, label: "Messages" },
  { path: "/admin/activity-log", icon: MdHistory, label: "Activity Log" },
  { path: "/admin/settings", icon: MdSettings, label: "Settings" },
  { path: "/admin/Profile", icon: CgProfile, label: "Profile" },
];

const Toolbar = ({ collapsed, mobileOpen, onToggleCollapse, onNavigate }) => {
  const location = useLocation();

  return (
    <nav
      className={`bt-toolbar ${collapsed ? "bt-toolbar--collapsed" : ""} ${mobileOpen ? "bt-toolbar--mobile-open" : ""}`}
      aria-label="Admin navigation"
    >
      <div className="bt-toolbar-brand">
        <span className="bt-toolbar-logo">
          <span className="bt-toolbar-logo__bake">Bake</span>
          <span className="bt-toolbar-logo__now">Now</span>
        </span>
        <button
          type="button"
          className="bt-toolbar-collapse"
          onClick={onToggleCollapse}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <BsChevronLeft />
        </button>
      </div>
      <div className="links">
        <ul>
          {NAV_ITEMS.map(({ path, icon: Icon, label }) => (
            <li key={path} className={location.pathname === path ? "active" : ""}>
              <Link to={path} title={label} onClick={onNavigate}>
                <Icon /> <span>{label}</span>
              </Link>
            </li>
          ))}
          <li>
            <Link to="/logout" title="Log Out" onClick={onNavigate}>
              <BiLogOut /> <span>Log Out</span>
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Toolbar;
